import React from "react";
import loadable from "@loadable/component";
import { Text, CbWrapper } from "@atoms";

const Video = loadable(() => import("../atoms/Video"));

const CbVideo = ({ videoUrl, caption, indent, type }) => {
  return (
    <CbWrapper type={type} indent={indent}>
      <div className="shadow-xl">
        <Video url={videoUrl} />
      </div>
      {caption && (
        <Text variant="caption" className="mt-4">
          {caption}
        </Text>
      )}
    </CbWrapper>
  );
};

CbVideo.defaultProps = {};

export default CbVideo;
